import type { FormStatus } from '../lib/forms';
import { Icon } from './Icon';

type Props = { status: FormStatus; error: string; successText: string; tone?: 'light' | 'dark' };

/** Polite live region announcing the result of a form submission. */
export function FormStatusMessage({ status, error, successText, tone = 'light' }: Props) {
  const dark = tone === 'dark';
  return (
    <div aria-live="polite" role="status" className="min-h-0">
      {status === 'success' && (
        <p className={`flex items-start gap-2 font-body-sm text-body-sm ${dark ? 'text-gold-light' : 'text-emerald-vivid'}`}>
          <Icon name="check_circle" size={18} className="mt-px" />
          <span>{successText}</span>
        </p>
      )}
      {status === 'error' && (
        <p className={`flex items-start gap-2 font-body-sm text-body-sm ${dark ? 'text-[#ffb4ab]' : 'text-error'}`}>
          <Icon name="error" size={18} className="mt-px" />
          <span>{error}</span>
        </p>
      )}
    </div>
  );
}
